module.exports = __webpack_public_path__ + "static/flags/RP-d38ce5e2da47c58051ec69e2aba5b232.gif";